import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { WSIBCodeSetup } from "../../components/WSIBCodeSetup";

export const WSIBCodeSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Code Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Code Setup", navigateTo: "#" }
      ]}
      mainContents={<WSIBCodeSetup />}
    />
  );
};
